<div class="wrapper">
    <div class="header">
        <div class="header-text">Recently viewed</div>
        <div class="filler"></div>
        <a class="clear-history" (click)="clearHistory()">Clear history</a>
    </div>
    <div class="content-wrapper search-scrolled-view">
        <app-empty-result *ngIf="!(history$|async)?.length"></app-empty-result>
        <div [hidden]="!(history$|async)?.length">
            <app-search-history-item *ngFor="let historyItem of history$|async;let i = index"
                [item]="historyItem" [itemIndex]="i"></app-search-history-item>
        </div>
    </div>
</div>
